import { useEffect, useState } from 'react'

import { toast } from 'react-toastify'

import { makeRanking } from '../../main/usecases/ranking/remote-ranking-factory'

import isHttpError from '../helpers/helper-http-error'

import { Ranks } from '../enums/ranks.enum'

const useFetchRanking = () => {
  const [rankingData, setRankingData] = useState<
    Record<Ranks, { title: string; score: number; id: number }[]>
  >({
    [Ranks.Especialidade]: [],
    [Ranks.Cidade]: [],
    [Ranks.Dia]: [],
    [Ranks.Hospital]: [],
  })

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const rankTypes = ['specialties', 'cities', 'week-days', 'contractors']
        const rankingPromises = rankTypes.map((type) => makeRanking().load(type))
        const ranking = await Promise.all(rankingPromises)

        const rankingObject: Record<
          Ranks,
          { title: string; score: number; id: number }[]
        > = {
          [Ranks.Especialidade]: ranking[0],
          [Ranks.Cidade]: ranking[1],
          [Ranks.Dia]: ranking[2],
          [Ranks.Hospital]: ranking[3],
        }

        setRankingData(rankingObject)
      } catch (error) {
        const httpError = isHttpError(error)

        if (httpError) {
          toast.error(httpError.message)
        } else {
          throw error
        }
      }
    }

    fetchRanking()
  }, [])

  return rankingData
}

export default useFetchRanking
